import React, { useEffect, useRef } from 'react';

const TradingViewTickers = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-tickers.js';
    script.async = true;
    script.crossOrigin = "anonymous";
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: 'TVC:USOIL', title: 'WTI Crude Oil' },
        { proName: 'DOTUSD', title: 'Polkadot Crypto' },
        { proName: 'TSX:IPO', title: 'InPlay Oil' },
        { proName: 'TSX:SPB', title: 'Superior Plus' },
        { proName: 'TSX:TAL', title: 'PetroTal Corp' },
        { proName: 'TSXV:LTC', title: 'Lotus Creek Exploration' },
        { proName: 'TSX:PNE', title: 'Pine Cliff Energy' },
        { proName: 'TSXV:LGN', title: 'Logan Energy Corp' }
      ],
      colorTheme: 'dark',
      locale: 'en',
      isTransparent: true,
      showSymbolLogo: true
    });
    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(script);
  }, []);

  return <div style={{ marginTop: '5px', width: '100%' }} ref={containerRef}></div>;
};

export default TradingViewTickers;
